// extracted by mini-css-extract-plugin
export var disabledOption = "_48-1";
export var dropdownItemWrapper = "_48-0";